import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { DialogComponentBase } from '@wephone-core-ui';
import { _tk } from 'jsphonelib/translation';
import * as _ from 'lodash';
import { DialogActionButton, Colors } from '@wephone-utils';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { _ti } from '@wephone-translation';
import { IssueReportService } from '@wephone-app-phone/services/issue-report.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-issue-report-modal',
  templateUrl: './issue-report-modal.component.html',
  styleUrls: ['./issue-report-modal.component.scss'],
})
export class IssueReportModalComponent extends DialogComponentBase implements OnInit {
  dialogTitle = _tk('issue_report.dialog.title');
  
  dialogLeftActions: DialogActionButton[] = [
    {
      label: _tk('public.navigation.prev'),
      action: () => {
        this.prev();
      },
      visible: () => {
        return this.step > 0;
      },
      color: Colors.PRIMARY,
    }
  ];

  dialogRightActions: DialogActionButton[] = [
    {
      label: _tk('public.navigation.next'),
      action: () => {
        this.next();
      },
      visible: () => {
        return this.step !== 2;
      },
      color: Colors.PRIMARY,
    },
    {
      label: _tk('public.submit'),
      action: () => {
        this.submit();
      },
      visible: () => {
        return this.step === 2;
      },
      color: Colors.PRIMARY,
    }
  ];

  step = 0;
  callId: number;
  forms: Record<number, FormGroup> = {};

  issueData = {
    problem_id: undefined,
    desc: undefined,
    last_call_problem: 1,
  };

  constructor(
    private readonly fb: FormBuilder,
    cdr: ChangeDetectorRef,
    dialogRef: MatDialogRef<IssueReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly issueReportService: IssueReportService,
  ) {
    super(dialogRef, cdr);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.forms = {
      0:  this.fb.group({
        last_call_problem: [1, [Validators.required]]
      }),
      1:  this.fb.group({
        problem_id: [undefined, [Validators.required]]
      }),
      2:  this.fb.group({
        desc: ['']
      })
    };

    if (this.data.call_id) {
      this.callId = this.data.call_id;
      this.step = 1;
    }
  }

  next(): void {
    // Validate
    const form = this.forms[this.step];
    if (form && form.invalid) {
      this.onFormInvalid(form);
      
      return;
    }

    if (this.step < 2) {
      this.step++;
    }

    this.updateDialogLayout();
  }

  prev(): void {
    if (this.step <= 0) {
      return;
    }

    this.step--;
  }

  private onFormInvalid(form: FormGroup): void {
    form.markAllAsTouched();
    this.updateDialogLayout();
    this.showError(_ti('public.message.data_invalid'));
  }

  async submit(): Promise<any> {
    for (const key of Object.keys(this.forms)) {
      const form = this.forms[+key];
      if (form && form.invalid) {
        this.onFormInvalid(form);
        this.step = +key;
        
        return;
      }
    }

    const data = {
      last_call_problem: this.forms[0].get('last_call_problem').value,
      problem_id: this.forms[1].get('problem_id').value,
      desc: this.forms[2].get('desc').value
    };

    if (this.callId) {
      _.extend(data, {
        call_id: this.callId
      });
    }

    try {
      await this.issueReportService.add(data);
      // console.log('data: ', data);
      this.toastService.showSuccess(_ti('public.message.create_success'));
      this.dismiss();
    } catch (error) {
      this.toastService.showErrorMessage(error, _ti('public.message.create_failed'));
    }
  }
}
